import React, { Component } from 'react'
import { connect } from 'react-redux'
import Modal from 'react-responsive-modal'
import moment from 'moment'
import request from 'superagent'
import util from '../../helper/util'

let denom_default = "../../swipe/assets/app/media/img/products/denom-default.jpg"

class ModalDenom extends Component {

    constructor(props) {
        super(props)
        this.state = {
            data_denom: [],
            show_komisi: false,
            show_komisi_url: ""
        }
    }

    componentDidMount() {
        let self = this
        this.get_denom()
    }

    get_denom() {
    	if (this.props.data.product_url) {
    		let body = {
                "session_id" : this.props.session
            }
            let self = this
            request.post(this.props.data.product_url)
                .set("Content-Type", "application/json")
                .send(body)
                .end(function(err, res) {
                    if (err || !res.ok) {
                        util.log("get_denom", err)
                    } else {
                        util.log("get_denom", res);
                        if (res.statusCode == 200) {
                            let payload = res.body
                            if (payload.status == "OK") {
                            	if (payload.results) {
                                    self.setState({data_denom: {data: payload.results.list}})
                                }
                            }
                        }
                    }
                })
    	}
    }

    detil_komisi(product_id, product_name, commision_url) {
        this.setState({show_komisi: true, show_komisi_url: commision_url})
    }

    render() {
        let self = this
    	let data = this.props.data
    	return (
	    	<Modal className="modal" open={true} center onClose={data.close} showCloseIcon={true} closeOnOverlayClick={true}>
	            <div className="modal-dialog modal-lg" role="document" style={{marginTop: 0+'px',marginBottom: 0+'px',width: '500px',minHeight:'600px'}}>
	                <div className="modal-content" style={{border:"white"}}>
	                    <div className="modal-header">
	                        <h5 className="modal-title">
	                            DENOM PRODUK {data.product_name}
	                        </h5>
	                    </div>
	                    <div className="modal-body">
	                        <div className="row">
	                        	<div className="col-lg-12">
			                        <div className="m-portlet__body">
                                        <div className="m-widget4">
		                                {this.state.data_denom.length !== 0 && this.state.data_denom.data !== undefined ?
                                            this.state.data_denom.data.map(function(item, key) {
                                                return (<div key={key} className="m-widget4__item">
                                                    <div className="m-widget4__img m-widget4__img--pic">
                                                        <img src={item.logo_filename !== null && item.logo_filename.length !== 0 ? item.logo_filename : denom_default} style={{height: 55+'px',width: 55+'px'}}/>
                                                    </div>
                                                    <div className="m-widget4__info">
                                                        <span className="m-widget4__title">
                                                            {item.product_name} ({item.denom})
                                                        </span>
                                                        <br/>
                                                        <div className="m-widget4__sub">
                                                            <span style={{fontWeight: 600}} className={item.is_active ? 'm--font-primary' : 'm--font-danger'}>{item.is_active ? 'ACTIVE' : 'INACTIVE'}</span>
                                                            <span style={{marginLeft: '5px'}}>{item.description}</span>
                                                            <br/>
                                                            {item.trx_fee ? <div>
                                                            <span title="End User Fee" className="m-badge m-badge--metal m-badge--wide m-badge--rounded" style={{marginTop: '5px'}}>EUF {item.trx_fee.fee_type === 'PERCENTAGE' ? item.trx_fee.end_user_fee_value + "%" : "Rp." + util.rupiah_format(item.trx_fee.end_user_fee_value)} </span>&nbsp;
                                                            <span title="Discount" className="m-badge m-badge--metal m-badge--wide m-badge--rounded" style={{marginTop: '5px'}}>Disc {item.trx_fee.discount_type === 'PERCENTAGE' ? item.trx_fee.discount_value + "%" : "Rp." + util.rupiah_format(item.trx_fee.discount_value)}</span>
                                                            </div> : ''}
                                                        </div>
                                                    </div>
                                                    <div className="m-widget4__ext" style={{display: 'flex',marginTop: '15px'}}>
                                                        <div className="dropdown">
                                                            <button className="btn btn-secondary" type="button" id="dropdownMenuButton" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false" style={{padding: '5px',borderRadius: '50%',marginLeft: '5px',height: '30px',width: '30px'}}>
                                                                <i className="la la-ellipsis-h" style={{fontSize: 'medium'}}></i>
                                                            </button>
                                                            <div className="dropdown-menu" aria-labelledby="dropdownMenuButton" x-placement="bottom-start" style={{position: 'absolute', transform: 'translate3d(0px, 37px, 0px)', top: '0px', left: '0px', willChange: 'transform'}}>

                                                                {item.next_commission && item.next_commission !== null ? <a className="dropdown-item" style={{cursor:'pointer'}} onClick={(e) => self.props.on_detil_komisi(item.product_id, item.product_code, item.product_name, item.next_commission.url)}>
                                                                    Komisi Setting
                                                                </a> : ''}

                                                                {item.next_bonus && item.next_bonus !== null ?<a className="dropdown-item" style={{cursor:'pointer'}} onClick={(e) => self.props.on_detil_bonus(item.product_id, item.product_code, item.product_name, item.next_bonus.url)}>
                                                                    Bonus Setting
                                                                </a> : ''}

                                                            </div>
                                                        </div>
                                                        
                                                    </div>
                                                </div>)
                                        })
                                        : <div style={{textAlign: 'center'}}>Tidak Ada Daftar Denom</div>}
                                        </div>
			                        </div>
			                    </div>

				            </div>
	                    </div>
	                </div>
	            </div>
	        </Modal>
        )
    }
}

const mapDispatchToProps = (dispatch) => ({
})

const mapStateToProps = (state) => ({
    session : state.Session,
    profile: state.Profile
})

export default connect(mapStateToProps, mapDispatchToProps)(ModalDenom)



// WEBPACK FOOTER //
// ./src/component/form/dialog_denom.js